const ADMIN = 'Administrator';
const CA = 'Credit Analyst';
const LO = 'Loan Officer';
const PM = 'Portfolio Manager';
const CCO = 'Chief Credit Officer';
const CLO = 'Chief Lending Officer';
const MISC = 'Misc';


export const test_token = {
  "testKey":"TestValue"
}

export const roles = { ADMIN, CA, LO, PM, CCO, CLO, MISC };

export default {
  roles
};

export const userIdsToSkipDdSession = ["losuiautomation@idexcel.com"]; 


